"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const InputMultiField_1 = __importDefault(require("../../../components/input/InputMultiField"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = __importDefault(require("../../../constants/constants"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const AsyncStorage_1 = __importDefault(require("../../../utils/AsyncStorage"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const ReasonDeleteScreen = () => {
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const refInputValue = (0, react_1.useRef)("");
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "アカウント削除", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: "#007AFF",
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), onLeftPress: () => {
                    (0, rootNavigation_1.navigate)(Routes_1.default.DELETE_ACCOUNT_SCREEN);
                } }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                fontWeight: "300",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u7406\u7531\u3092\u4EE5\u4E0B\u306B\u3054\u8A18\u5165\u304F\u3060\u3055\u3044\u3002")),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row", marginBottom: (0, scale_1.scale)(24) } },
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: "#545454",
                            } }, "\u203B"),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: "#545454",
                            } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u5F53\u30B5\u30FC\u30D3\u30B9\u306E\u5168\u3066\u306E\u6A5F\u80FD\u304C\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u524A\u9664\u306F\u53D6\u308A\u6D88\u3057\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002")),
                    react_1.default.createElement(InputMultiField_1.default, { placeholder: "\u30B5\u30FC\u30D3\u30B9\u306E\u54C1\u8CEA\u5411\u4E0A\u306E\u305F\u3081\u304A\u5BA2\u69D8\u306E\u304A\u58F0\u3092\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044\u3002", placeholderTextColor: "#C8C8C8", 
                        // label={'ラベル'}
                        label: '', maxLength: 1000, inputContainerStyle: {
                            height: (0, scale_1.verticalScale)(155),
                        }, inputStyle: {
                            height: 'auto',
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(22.5),
                            color: '#292A33',
                            paddingVertical: (0, scale_1.scale)(8.5),
                            paddingHorizontal: (0, scale_1.scale)(10),
                        }, onChangeText: (text) => {
                            refInputValue.current = text;
                        }, errorText: errorMessage }),
                    react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664\u3092\u78BA\u8A8D", onPress: async () => {
                            refInputValue.current = refInputValue.current.trim();
                            await (!!refInputValue.current ?
                                AsyncStorage_1.default.set(constants_1.default.REASON_DELETE, refInputValue.current)
                                :
                                    AsyncStorage_1.default.remove(constants_1.default.REASON_DELETE));
                            (0, rootNavigation_1.navigate)(Routes_1.default.CONFIRM_DELETE_ACCOUNT_SCREEN);
                        } }))))));
};
exports.default = ReasonDeleteScreen;
